import {Paper} from '@mui/material';
import React from 'react';
import dimensions from '@explorer/styles/dimensions';

const Container = props => (
  <Paper
    square
    elevation={4}
    className="pl-mode-dark"
    sx={{
      width: dimensions.sideNav.width,
      height: '100%',
      position: 'relative',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      zIndex: theme => theme.zIndex.drawer + 1,
    }}
    {...props}
  />
);

export default Container;
